export enum AdminProfileFieldsNames {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  ID = 'id',
}

export enum ChangePasswordFieldsNames {
  OLD_PASSWORD = 'oldPassword',
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirmPassword',
}

export type TAdminProfileFormValues = {
  [AdminProfileFieldsNames.FIRST_NAME]: string;
  [AdminProfileFieldsNames.ID]: string;
  [AdminProfileFieldsNames.LAST_NAME]: string;
  [AdminProfileFieldsNames.EMAIL]: string;
};

export type TChangePasswordFieldsNamesValues = {
  [ChangePasswordFieldsNames.OLD_PASSWORD]: string;
  [ChangePasswordFieldsNames.PASSWORD]: string;
  [ChangePasswordFieldsNames.CONFIRM_PASSWORD]: string;
};
